export const PaymentBlock = {
  props: ['financeValue', 'leaseValue', 'cashRebate', 'financeData', 'priceValue', 'msrpValue', 'salePrice', 'lang', 'provinceTax','frequencySelected', 'useMsrp','taxed','showEffectiveRtFinance','showEffectiveRtLease', 'customDownPayment'],
  data() {
    return {
      cashRebateValue: this.cashRebate,
      finance: this.financeValue,
      isTaxed: (this.taxed && (this.taxed == 'true' || this.taxed == '1')) ? true : false,
      lease: this.leaseValue,
      provinceTaxValue: this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13,
      isLease: false,
      discountsVisibility: false,
      discountsStatus: 'closed',
      discountsAddIcon: '+',
      financeDetailsVisibility: false,
      financeAddIcon: '+',
      leaseDetailsVisibility: false,
      leaseAddIcon: '+',
      calculatedValue: 0, //*payment finance
      calculatedLeaseValue: 0, //*payment lease
      loanTerm: 0, // *lease term in month finanse
      loanTermLease: 0, // *lease term in month lease
      downPayment: this.customDownPayment ? this.customDownPayment : 0,
      tradeInValue: 0,
      frequency: this.frequencySelected ? this.frequencySelected : 'weekly',
      vehiclePrice: (this.useMsrp ? this.salePrice : this.priceValue + this.cashRebate),
      salesTax: 0,
      interestRate: 0,
      interestRateLease: 0,
      costOfBorrowing: 0,
      costOfBorrowingLease: 0,
      totalMSRP: this.msrpValue,
      termsMock: [
        { term: 12, value: 0 },
        { term: 24, value: 0 },
        { term: 36, value: 0 },
        { term: 48, value: 0 },
        { term: 60, value: 0 },
        { term: 72, value: 0 },
        { term: 84, value: 0 },
      ],
      kilometersAllowance: 25000,
      showDiscounts: false,
      flotanteTranslateX: "0",
      discountsText: 'Expand +',
    }
  },

  methods: {
    financeDetails(){
      this.leaseDetailsVisibility = false
      this.financeDetailsVisibility = !this.financeDetailsVisibility;
      this.financeStatus = 'opening'
      if(this.financeAddIcon == '+')
        this.financeAddIcon = '-'
      else
        this.financeAddIcon = '+'
    },
    financeDetailsOff() {
      if (this.financeStatus =='open' || this.financeStatus == 'opening'){
        this.financeDetailsVisibility = false
        this.financeAddIcon = '+'
        this.financeStatus = 'closed'
      }

      if(this.financeStatus == 'opening'){
        this.financeStatus = 'open'
      }
    },
    discountsDetails(){
      this.discountsVisibility = !this.discountsVisibility;
      this.discountsStatus = 'opening'
      if(this.discountsAddIcon == '+')
        this.discountsAddIcon = '-'
      else
        this.discountsAddIcon = '+'
    },
     leaseDetailsOpen(){
        this.financeDetailsVisibility = false;
        this.leaseDetailsVisibility = !this.leaseDetailsVisibility;
        this.leaseStatus = 'open';
        this.$nextTick(() => {
          this.calculateAdjustedPosition();
        });
      },
      leaseDetailsClose(){
        if (this.leaseStatus =='open'){
          this.leaseDetailsVisibility = false
          this.leaseStatus = 'closed'
        }
        if(this.leaseStatus == 'opening'){
          this.leaseStatus = 'closed'
        }
      },
    calculateAdjustedPosition() {
        const componentRoot = this.$el;
        if (componentRoot) {
          const boundingRect = componentRoot.getBoundingClientRect();
          const viewportWidth = window.innerWidth;
          const posicion = boundingRect.left + (boundingRect.width * 0.85);
          if (posicion + 288 > viewportWidth) {
            const adjustedTranslateX = viewportWidth - (posicion + 288 + 20);
            this.flotanteTranslateX = adjustedTranslateX + "px";
          } else {
            this.flotanteTranslateX = 0;
          }
        }
      },
    usdFormat(value) {
      var formatter = new Intl.NumberFormat(this.lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
      });

      return formatter.format(value);
    },
    frequencyFormat(value) { 
      if (this.lang == 'fr-CA') {
        if (value == 'weekly') return 'Semaine';
        if (value == 'bi-weekly') return 'Aux deux semaines';
        if (value == 'monthly') return 'Mensuel';
      }
      else
        return value;
    },
    onFocus(value) {
      if (value == 'downPayment' && this.downPayment == 0){
        this.downPayment = '';
    }
      if (value == 'tradeInValue' && this.tradeInValue == 0){
        this.tradeInValue = '';
      }
    },
    blur(value) {
      if (value == 'downPayment' && this.downPayment == ''){
          this.downPayment = 0;
      }
      if (value == 'tradeInValue' && this.tradeInValue == ''){
        this.tradeInValue = 0;
      }
    },
    handleTax() {
      this.isTaxed = !this.isTaxed;
    },
    handleDiscounts() {
      this.showDiscounts = !this.showDiscounts;
      if (this.showDiscounts) {
        this.discountsText = 'Collapse -';
      } else {
        this.resetRangeSlider();
        this.discountsText = 'Expand +';
      }
    },
    resetRangeSlider() {
      /**
       * It takes the value of the input and uses it to set the background size of the input
       * @param e - The event object.
      */
     setTimeout(function () {
        const rangeInputs = document.querySelectorAll('input[type="range"].atum-input-range');

        if (!rangeInputs.length) {
          return;
        }

        function handleInputChange(e) {
          let target = e.target
          if (e.target.type !== 'range') {
            target = document.getElementById('range')
          }
          const min = target.min
          const max = target.max
          const val = target.value

          target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'
        }

        /* Calling the handleInputChange function with the first rangeInputs element as the target. */
        for (let i = 0; i < rangeInputs.length; i++) {
          handleInputChange({ target: rangeInputs[i] });
        }
      }, 50)
    },
    numberFormat(value) {
      return new Intl.NumberFormat(this.lang).format(value);
    },
    atumCalculatorRange() {
      this.calculatePayment();
      this.calculateLeasePayment();
    },
    toggle: function () {
      this.isLease = !this.isLease
      this.loanTerm = this.termsOptions[this.termsOptions.length - 1];
      this.changeInterestRate();
      this.changeInterestRateLease();
      this.calculatePayment();
      this.calculateLeasePayment();
    },
    togglePlan: function (plan) {
      this.frequency = plan;
      this.calculatePayment();
      this.calculateLeasePayment();
    },
    close: function () {
      this.$emit('close');
    },
    calculatePayment: function () {

        var total = 0
        var term = 60
        if (this.loanTerm != 0)
          term = this.loanTerm;
        if (this.interestRate == 0)
          total = Math.round(((this.remainingVehiclePrice - this.residual) / term) * 100) / 100;
        else
          total = Math.round((((this.remainingVehiclePrice - this.residual) * (this.interestRate / 1200)) * Math.pow((1 + (this.interestRate / 1200)), term)) / (Math.pow((1 + (this.interestRate / 1200)), term) - 1) * 100) / 100;

        this.amountFinanced = (Math.round(total * term) * 100 / 100)
        this.costOfBorrowing = (this.amountFinanced - this.remainingVehiclePrice) *  ( this.provinceTaxValue);
        if (this.costOfBorrowing < 0)
          this.costOfBorrowing = 0;

        if (this.frequency == "weekly")
          this.calculatedValue = Math.round(((total * 12) / 52).toFixed(2));
        else if (this.frequency == "bi-weekly")
          this.calculatedValue = Math.round(((total * 12) / 26).toFixed(2));
        else
          this.calculatedValue = Math.round(total.toFixed(2));

      // alert("CALCULATE" + this.calculatedValue);
    },
    calculateLeasePayment: function () {
      this.isLease = true;
      var total = 0
      var depretation = ((this.remainingVehiclePrice - this.residualLease) / this.loanTermLease);
      var moneyFactor = (this.interestRateLease / 2400)
      var financingFeeLease = ((this.residualLease + this.remainingVehiclePrice) * moneyFactor)

      total = financingFeeLease + depretation

      this.amountFinanced = this.remainingVehiclePrice - this.residualLease;
      this.costOfBorrowingLease = ((total * this.loanTermLease) - this.amountFinanced)

      if (this.costOfBorrowingLease < 0)
        this.costOfBorrowingLease = 0;

      if (this.frequency == "weekly"){
        this.calculatedLeaseValue = Math.round(((total * 12) / 52).toFixed(2));
      }
      else if (this.frequency == "bi-weekly")
        this.calculatedLeaseValue = Math.round(((total * 12) / 26).toFixed(2));
      else
        this.calculatedLeaseValue = Math.round((total).toFixed(2));

      let provinceDealerTax = this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13;
      this.isTaxed ? this.calculatedLeaseValue = Math.round((this.calculatedLeaseValue * provinceDealerTax).toFixed(2)) : this.calculatedLeaseValue;
      this.isLease = false;
    },
    changeInterestRate() {
      this.setInterestRate();
      this.calculatePayment();
    },
    changeInterestRateLease() {
      this.setInterestRateLease();
      this.calculateLeasePayment();
    },
    setInterestRate() {
      const index = this.terms.map(item => { return item.term }).indexOf(this.loanTerm);
      if (this.terms[index].value > 50)
        this.interestRate = parseFloat(Math.round(this.terms[index].value * 100) / 100) / 100;
      else
        this.interestRate = parseFloat(Math.round(this.terms[index].value * 100) / 100);
    },
    setInterestRateLease() {

      var index = -1;

      if (this.loanTermLease) index = this.termsLease.map(item => { return item.term }).indexOf(this.loanTermLease);

      if (index > -1) {
        if (this.termsLease[index].value > 50)
          this.interestRateLease = parseFloat(Math.round(this.termsLease[index].value * 100) / 100) / 100;
        else
          this.interestRateLease = parseFloat(Math.round(this.termsLease[index].value * 100) / 100);
      } else {
        this.interestRateLease = 0;
      }
    },
    //* Effective rate calculation
    calculateEffectiveRate(leasePaymentsPerYear, leaseTerm, payment, presentValue, residualValue, type = 1, guess = 0.00035, tolerance = 1e-12, maxIterations = 10000) {
      const nper = leaseTerm * leasePaymentsPerYear;
      function calculateRate(nper, payment, presentValue, residualValue, type, guess, tolerance, maxIterations) {
          let rate = guess;
          for (let i = 0; i < maxIterations; i++) {
              // Cálculo del NPV
              const npv = presentValue +
                          payment * ((1 + rate * type) * (1 - Math.pow(1 + rate, -nper)) / rate) +
                          residualValue * Math.pow(1 + rate, -nper);
              // Método de Newton modificado
              const newRate = rate * (1 - npv / (presentValue + Math.abs(npv)));
              if (Math.abs(newRate - rate) < tolerance) {
                  return newRate;
              }
              rate = newRate;
          }
          return null;
      }
      const ratePerPeriod = calculateRate(nper, -payment, presentValue, -residualValue, type, guess, tolerance, maxIterations);
      if (ratePerPeriod !== null) {
          // Ajuste en el cálculo de la tasa anual
          const annualRate = ratePerPeriod * leasePaymentsPerYear;
          return (annualRate * 100).toFixed(3) + "%";
      }
      return "Error: Cannot calculate rate.";
    }
  },
  computed: {
    obligation(){
      //return ((this.vehiclePrice *  ( this.provinceTaxValue)) * (1 + (this.interestRateLease / 100)));
      return ((this.vehiclePrice *  ( this.provinceTaxValue)) + this.costOfBorrowing);
    },
    obligationLease(){
      //return ((this.vehiclePrice *  ( this.provinceTaxValue)) * (1 + (this.interestRateLease / 100)));
      return ((this.vehiclePrice *  ( this.provinceTaxValue)) + this.costOfBorrowingLease );
    },
    leaseAdjustment() {
      if (!this.metadataLease)
        return 0;

      try {
        if(this.metadataLease.adjustments.adjustment){
            // var optionIndex = this.metadataLease.adjustments.adjustment.map(item => { return item.mileage }).indexOf(this.hasKmsAllowanceLease)
            var optionIndex = this.metadataLease.adjustments.adjustment.map(item => { return item.mileage }).indexOf(this.kilometersAllowance)
            return this.metadataLease.adjustments.adjustment[optionIndex].adjustment;
        }else{
            // var optionIndex = this.metadataLease.adjustments.map(item => { return item.mileage }).indexOf(this.hasKmsAllowanceLease)
            var optionIndex = this.metadataLease.adjustments.map(item => { return item.mileage }).indexOf(this.kilometersAllowance)
            return this.metadataLease.adjustments[optionIndex].adjustment;
        }

      } catch (e) {
        return 0;
      }
    },
    hasKmsAllowance() {
      if (!this.metadata || !this.metadata.adjustments)
        return false;
      else
        return true;
    },
    hasKmsAllowanceLease() {
      if (!this.metadataLease || !this.metadataLease.adjustments)
        return false;
      else
        return true;
    },
    metadata() {
      if (!this.isLease)
        return null;

      var optionIndex = this.lease.map(item => { return item.term }).indexOf(this.loanTerm);
      if (optionIndex == -1)
        return null;
      else
        try {
          return JSON.parse(this.lease[optionIndex].metadata) || null;
        }
        catch (e) {
          return null;
        }
    },
    metadataLease() {
      if (!this.lease)
        return null;
      var optionIndex = this.lease.map(item => { return item.term }).indexOf(this.loanTermLease);
      if (optionIndex == -1)
        return null;
      else
        try {
          return JSON.parse(this.lease[optionIndex].metadata) || null;
        }
        catch (e) {
          return null;
        }
    },
    allowanceMileages() {
        // This calculation was changed because the Finance|Lease toggle button does not influence this issue.
        // NOTE: The lease total does not change according to the mileage, but rather according to the adjustment.
        if(this.metadataLease){
          if(this.metadataLease.adjustments.adjustment)
              var obj = this.metadataLease.adjustments.adjustment;
          else
              var obj = this.metadataLease.adjustments;

          var allowedMileages = {};

          for (const prop in obj)
              allowedMileages[prop] = obj[prop]["mileage"];

          this.kilometersAllowance = allowedMileages[0];
          return allowedMileages;

      }else
          return null;
    },
    residual() {
      if (!this.isLease)
        return 0;
    },
    residualLease() {
      if (!this.lease)
        return 0;

      const index = this.lease.map(item => { return item.term }).indexOf(this.loanTermLease);
      if (index == -1)
        return 0;

      var metadata = null;
      try {
        metadata = this.lease[index].metadata;
        return (this.salePrice + this.cashRebate) * (parseFloat(JSON.parse(metadata).residual.value) + this.leaseAdjustment) / 100;
      }
      catch (e) {
        return 0;
      }
    },
    remainingVehiclePrice() {
      var downPaymentN;
      var tradeInValueN;


      if (this.downPayment) {
        downPaymentN = (this.downPayment.length > 0) ? parseInt(this.downPayment) : 0;
      } else {
        downPaymentN = 0;
      }

      if (this.tradeInValue) {
        tradeInValueN = (this.tradeInValue.length > 0) ? parseInt(this.tradeInValue) : 0;
      } else {
        tradeInValueN = 0;
      }

      this.$cookies.set('downPayment', downPaymentN);
      this.$cookies.set('tradeInValue', tradeInValueN);

      var vehiclePrice = parseInt(this.vehiclePrice);
      var result = vehiclePrice;

      if (!this.isLease) {
        let provinceDealerTax = this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13;
        this.isTaxed ? result = result * provinceDealerTax : result;
      }
      

      if(tradeInValueN || downPaymentN) {
        if (tradeInValueN) {
          result = result - tradeInValueN;
        }

        if (downPaymentN) {
          result = (result) -  (downPaymentN / this.provinceTaxValue) ;
        }
      }
      else{
        //result = (result * this.provinceTaxValue);
      }


      return result;
    },
    selectedMethod() {
      if (this.isLease)
        return this.lease;
      else
        return this.finance;
    },
    terms() {
      var duplicatedMonths = this.finance.map(item => { return { term: item.term, value: item.value } });
      var visited = [];
      var months = duplicatedMonths.filter(item => {
        if (visited.indexOf(item.term) == -1) {
          visited.push(item.term);
          return item;
        }
      })
      if (months == null) {
        return [];
      }
      return months
    },
    termsLease() {
      if(!this.lease)
        return [];
      var duplicatedMonths = this.lease.map(item => { return { term: item.term, value: item.value } });
      var visited = [];
      var months = duplicatedMonths.filter(item => {
        if (visited.indexOf(item.term) == -1) {
          visited.push(item.term);
          return item;
        }
      })
      if (months == null) {
        return [];
      }
      return months
    },
    termsOptions() {
      return this.terms.sort((a, b) => a.term - b.term).map(item => { return item.term });
    },
    termsOptionsLease() {
      return this.termsLease.sort((a, b) => a.term - b.term).map(item => { return item.term });
    },
    // payments in the year
    paymentPerYear(){
      if (this.frequency == "weekly")
        return  52;
      else if (this.frequency == "bi-weekly")
        return 26;
      else
      return 12;
    },
    effectiveRateLease() {
      return this.calculateEffectiveRate(
        this.paymentPerYear,
        this.loanTermLease / 12,
        this.calculatedLeaseValue,
        this.priceValue,
        this.residualLease
      );
    },
    effectiveRateFinance() {
      return this.calculateEffectiveRate(
        this.paymentPerYear,
        this.loanTerm / 12,
        this.calculatedValue,
        this.priceValue,
        0
      );

    },

  },
  mounted() {
    /**
     * It takes the value of the input and uses it to set the background size of the input
     * @param e - The event object.
     */
    const rangeInputs = document.querySelectorAll('input[type="range"].atum-input-range')
    const numberInputs = document.querySelectorAll('input[type="number"].atum-input-number')

    if (!rangeInputs.length && !numberInputs.length) {
      return;
    }

    function handleInputChange(e) {
      let target = e.target
      if (e.target.type !== 'range') {
        target = document.getElementById('range')
      }
      const min = target.min
      const max = target.max
      const val = target.value

      target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'
    }

    [...rangeInputs, ...numberInputs].forEach(input => {
      input.addEventListener('input', handleInputChange)
    })


    /* Calling the handleInputChange function with the first rangeInputs element as the target. */
    for (let i = 0; i < rangeInputs.length; i++) {
      handleInputChange({ target: rangeInputs[i] });
    }
  },
  watch: {
    remainingVehiclePrice() {
      this.calculatePayment();
      this.calculateLeasePayment();
    }
  },
  filters: {

  },
  beforeMount() {
    this.kilometersAllowance = (this.allowanceMileages && this.allowanceMileages.length > 0) ? this.allowanceMileages[0] : this.kilometersAllowance ;
    this.calculatePayment();
    this.calculateLeasePayment();
  },
  created() {
    if (this.finance && (this.finance.length == 0))
      this.finance = this.termsMock;
    if (this.lease && (this.lease.length == 0))
      this.lease = this.termsMock;

    console.log(this.taxed );

    this.loanTerm = this.termsOptions[this.termsOptions.length - 1];
    this.loanTermLease = this.termsOptionsLease[this.termsOptionsLease.length - 1];
    this.setInterestRate();
    this.setInterestRateLease();
  },
}
